import { STORE_NAME } from './STORE';
/*
 *  Copyright (c) 2003-2019 GameDuell GmbH, All Rights Reserved
 *  This document is strictly confidential and sole property of GameDuell GmbH, Berlin, Germany
 */
/**
 * localStorage scope GD
 */
var GD = /** @class */ (function () {
    function GD() {
        var gd = JSON.parse(localStorage.getItem('gd') || '{}');
        this.viewLang = gd.viewLang;
        this.viewCountry = gd.viewCountry;
        this.webCtxPath = gd.webCtxPath || '/web';
        this.mediaUrl = gd.mediaUrl || '//assets.gameduell.de/res/moduleMedia/';
        this.avatarUrl = gd.avatarUrl || '//assets.gameduell.de/avatar/';
        this.partner = {
            name: (gd.partner && gd.partner.name) || '',
            url: (gd.partner && gd.partner.url) || '',
        };
        this.supportedLocales = gd.supportedLocales || [
            'en-US',
            'en-GB',
            // 'es-ES',
            // 'fr-FR',
            'nl-NL',
            'se-SV',
            'da-DK',
            'de-DE',
            'de-AT',
        ];
        this.supportedTechs = gd.supportedTechs || ['html5_dom'];
        this.blackRibbon = gd.blackRibbon || false;
        this.theme = gd.theme || '';
        this.cookieConsent = {
            consented: (gd.cookieConsent && gd.cookieConsent.consented) || false,
            auto: (gd.cookieConsent && gd.cookieConsent.auto) || false,
            functional: (gd.cookieConsent && gd.cookieConsent.functional) || false,
            marketing: (gd.cookieConsent && gd.cookieConsent.marketing) || false,
            names: (gd.cookieConsent && gd.cookieConsent.names) || [
                STORE_NAME.ACCESS_TOKEN,
                STORE_NAME.ACCOUNTBOX,
                STORE_NAME.CID,
                STORE_NAME.COOKIE_CONSENT,
                STORE_NAME.GD,
                STORE_NAME.HOME_ESSENTIAL,
                STORE_NAME.JSESSIONID,
                STORE_NAME.PHONITAIRE,
                STORE_NAME.SHOP_WEB,
                STORE_NAME.SHOP_ESSENTIAL,
                STORE_NAME.SESSION_HOST,
                STORE_NAME.USER,
            ],
        };
        this.decisions = gd.decisions || [];
        this.mobileDevice = gd.mobileDevice || false;
        this.betaMobil = gd.betaMobil || false;
        this.deviceType = gd.deviceType || 'desktop';
        this.trackingConfig = gd.trackingConfig || [];
    }
    return GD;
}());
export { GD };
//# sourceMappingURL=GD.js.map